import React, { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { getAll, getAllCountries } from '../../api';
import WorldMap from '../../components/Map';
import GlobalStats from '../../components/WorldStats';
import { useStore } from '../../Store';

function Main() {
  const { state, dispatch } = useStore();
  const [covid19Data, setCovid19Data] = useState({});
  const [tooltipContent, setTooltipContent] = useState({});

  useEffect(() => {
    (async function getData() {
      const data = await getAll();
      setCovid19Data(() => data);
    })();
  }, []);

  useEffect(() => {
    (async function getAllCountriesData() {
      const data = await getAllCountries();
      dispatch({ type: 'SET_COUNTRIES', payload: data });
    })();
  }, [dispatch]);

  return (
    <>
      <GlobalStats stats={covid19Data} />
      <WorldMap
        setTooltipContent={setTooltipContent}
        covid19DataScale={covid19Data.cases}
        countriesData={state.countries}
      />
      {tooltipContent.length !== 0 && (
        <ReactTooltip className="reacttooltip" >
          <h4>{tooltipContent.name && tooltipContent.name}</h4>
          {tooltipContent.cases && <h5>Cases: {tooltipContent.cases}</h5>}
          {tooltipContent.recovered && (
            <h5>Recovered: {tooltipContent.recovered}</h5>
          )}
          {tooltipContent.deaths && <h5>Deaths: {tooltipContent.deaths}</h5>}
        </ReactTooltip>
      )}

    </>
  );
}

export default Main;
